import angular from 'angular';
import component from './contact-group-warnings.component';

const contactGroupWarningsModule = angular
    .module('dt.components.organization-alert-config.alert-templates.template-detail.contact-group-warnings', [])
    .component('contactGroupWarnings', component);

export default contactGroupWarningsModule.name;
